export default function initFieldCounter(el: HTMLElement) {
    const counters = el.querySelectorAll('span.count-value') as NodeListOf<HTMLSpanElement>;
    if (counters.length < 1) {
        return;
    }

    counters.forEach(counter => {
        const target = el.querySelector('#' + counter.dataset.target) as HTMLInputElement;
        if (target) {
            const initial = parseInt(counter.innerText, 10);
            const updateCounter = () => {
                counter.innerText = (initial - target.value.length).toString();
            };
            target.addEventListener('input', updateCounter);
            updateCounter();
        }
    });
}